import { useEffect, useRef } from "react";

/**
 * Thin gradient progress bar at the top of the viewport.
 * Width = (scrollY / max) * 100%. Pure CSS transform for smoothness.
 */
export default function ScrollProgress() {
  const fillRef = useRef(null);

  useEffect(() => {
    const reduced = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    if (reduced) return;

    let raf = 0;
    let target = 0;
    let current = 0;

    const measure = () => {
      const doc = document.documentElement;
      const max = doc.scrollHeight - window.innerHeight;
      target = max > 0 ? Math.min(1, Math.max(0, window.scrollY / max)) : 0;
    };

    const loop = () => {
      current += (target - current) * 0.2;
      if (fillRef.current) {
        fillRef.current.style.transform = `scaleX(${current.toFixed(4)})`;
      }
      raf = requestAnimationFrame(loop);
    };

    measure();
    loop();
    window.addEventListener("scroll", measure, { passive: true });
    window.addEventListener("resize", measure);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("scroll", measure);
      window.removeEventListener("resize", measure);
    };
  }, []);

  return (
    <div
      className="scroll-progress"
      aria-hidden="true"
      data-testid="scroll-progress"
    >
      <div ref={fillRef} className="scroll-progress-fill" />
    </div>
  );
}
